<div class="card shadow-sm">

  @if (title) {
    <div class="card-header" [ngClass]="headerStyle">
      <div class="row">
        <div class="col-12 text-center">
          <h4 class="d-inline">{{ title | translate | titlecase }}</h4>
          <ng-content select="[header-right]"></ng-content>
        </div>
        <ng-content select="[header-subtitle]"></ng-content>
      </div>
    </div>
  }

  <div class="card-body">
    <ng-content></ng-content>
  </div>

</div>